import React from 'react';
import {NestedList, SimpleList, SimpleListNoLink} from './NestedList';

const AllNestedLink = ({NestedField}) => {

	const CreateCriteres = ({critereArray, linkLocation}) => {
		return (
			critereArray.map((critere) => <SimpleList key={`c-${critere.pos}`} itemName={`Critères ${critere.pos}`} linkLocation={`${linkLocation}/${critere.pos}`} />)
		)
	}

	const CreateReference = ({referenceArray, linkLocation}) => {
		return (
			referenceArray.map((ref) => <NestedList key={`ref-${ref.pos}`} linkLocation={`${linkLocation}/${ref.pos}`} itemName={`Reference ${ref.pos}`} Children={() => <CreateCriteres critereArray={ref.criteres} linkLocation={`${linkLocation}/${ref.pos}`} />}/>)
		)
	}

	const CreateReferentiel = ({referentielArray, linkLocation}) => {
		return (
			referentielArray.map((rel) => <NestedList key={`rel-${rel.pos}`} linkLocation={`${linkLocation}/${rel.pos}`} itemName={`Referentiel ${rel.pos}`} Children={() => <CreateReference referenceArray={rel.references} linkLocation={`${linkLocation}/${rel.pos}`}/>}/>)
		)
	}

	const CreateDomaine = ({domaine, linkLocation}) => {
		return <NestedList key={`dom-${domaine.pos}`} linkLocation={linkLocation} itemName={`Domaine ${domaine.pos}`}  Children={() => <CreateReferentiel referentielArray={domaine.referentiel} linkLocation={linkLocation} />}/>
	}

	const AllDomaine = () => {
		return (
			<>
				<CreateDomaine domaine={NestedField.domaine} linkLocation={`/domaine/${NestedField.domaine.pos}`} />
				<SimpleListNoLink itemName='Domaine 2' linkLocation={null} />
				<SimpleListNoLink itemName='Domaine 3' linkLocation={null} />
			</>
		)
	}
	return(
	<>
		{ NestedField && 
			<NestedList itemName='Evaluation' Children={() => <AllDomaine />} />
		}
	</>)
}

/* <CreateDomaine domaine={NestedField.domaine} linkLocation={`/domaine/${NestedField.domaine.pos}`/> */

export default AllNestedLink;